import { render, staticRenderFns } from "./coalbutton.vue?vue&type=template&id=d9b878ca&scoped=true&"
import script from "./coalbutton.vue?vue&type=script&lang=js&"
export * from "./coalbutton.vue?vue&type=script&lang=js&"
import style0 from "./coalbutton.vue?vue&type=style&index=0&id=d9b878ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b878ca",
  null
  
)

export default component.exports